import { GroupChipExpression, SimpleChipExpression } from '@nrwl/query-emitter';

export abstract class KeywordToResourceResolver {
  abstract translateExpressions(
    kpiName: string,
    expression: SimpleChipExpression[] | GroupChipExpression[]
  ): SimpleChipExpression[] | GroupChipExpression[];
  abstract translateKeywords(kpiName: string, keywords: string[]): string[];
  abstract translateKpiName(kpiName: string, groupby: string): string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  abstract enrichResponseCallback(next: Function, timePickerUpdateNotRequested?: boolean): Function;
}
